import appConfig from "../config/index";


export const httpLog = (...argus) => {
    appConfig.httpLog && console.log(...argus)
}

export const httpWarnLog = (...argus) => {
    appConfig.httpLog && console.warn(...argus)
}

export const httpErrorLog = (...argus) => {
    appConfig.httpLog && console.error(...argus)
}

export const safeLog = ()=>{
    console.log('/*\n' +
        ' *                        _oo0oo_\n' +
        ' *                       o8888888o\n' +
        ' *                       88" . "88\n' +
        ' *                       (| -_- |)\n' +
        ' *                       0\\\\  =  /0\n' +
        ' *                     ___/\\`---\'\\\\___\n' +
        ' *                   .\' \\\\\\\\|     |// \'.\n' +
        ' *                  / \\\\\\\\|||  :  |||// \\\\\n' +
        ' *                 / _||||| -:- |||||- \\\\\n' +
        ' *                |   | \\\\\\\\\\\\  - /// |   |\n' +
        ' *                | \\\\_|  \'\'\\\\---/\'\'  |_/ |\n' +
        ' *                \\\\  .-\\\\__  \'-\'  ___/-. /\n' +
        ' *              ___\'. .\'  /--.--\\\\  \\`. .\'___\n' +
        ' *           ."" \'<  \\`.___\\\\_<|>_/___.\' >\' "".\n' +
        ' *          | | :  \\`- \\\\`.;\\`\\\\ _ /\\`;.\\`/ - \\` : | |\n' +
        ' *          \\\\  \\\\ \\`_.   \\\\_ __\\\\ /__ _/   .-\\` /  /\n' +
        ' *      =====\\`-.____\\`.___ \\\\_____/___.-\\`___.-\'=====\n' +
        ' *                        \\`=---=\'\n' +
        ' *\n' +
        ' *\n' +
        ' *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n' +
        ' *\n' +
        ' *            佛祖保佑                 永无BUG\n' +
        ' */')
}
